module.exports = __webpack_public_path__ + "static/img/irole.410ef01.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/role3/wxsjglm/irole.png
// module id = 7DyG
// module chunks = 7